/* Color sibling swatches: hover a card swatch to preview that colorway's photo. */
(function () {
  if (window.__colorSiblingsInit) return;
  window.__colorSiblingsInit = true;

  function mainImg(card) {
    var mask = card.querySelector('.grid-product__image-mask');
    if (!mask) return null;
    var imgs = mask.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].closest('.grid-product__secondary-image')) return imgs[i];
    }
    return null;
  }

  function swap(sw) {
    var card = sw.closest('.grid-product');
    if (!card || !sw.dataset.csSrc) return;
    var img = mainImg(card);
    if (!img) return;
    if (!img.hasAttribute('data-cs-orig-src')) {
      img.setAttribute('data-cs-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-cs-orig-srcset', img.getAttribute('srcset') || '');
    }
    card.classList.add('cs-swapping');
    img.setAttribute('srcset', sw.dataset.csSrcset || '');
    img.setAttribute('src', sw.dataset.csSrc);
  }

  function restore(list) {
    var card = list.closest('.grid-product');
    if (!card) return;
    var img = mainImg(card);
    card.classList.remove('cs-swapping');
    if (!img || !img.hasAttribute('data-cs-orig-src')) return;
    var oss = img.getAttribute('data-cs-orig-srcset');
    if (oss) img.setAttribute('srcset', oss); else img.removeAttribute('srcset');
    img.setAttribute('src', img.getAttribute('data-cs-orig-src'));
  }

  // Preload the colorway photos when the shopper first moves onto a card.
  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var sw = e.target.closest('.cs-card__swatch');
    if (sw) { swap(sw); return; }
    var card = e.target.closest('.grid-product');
    if (card && !card.__csPreloaded) {
      card.__csPreloaded = true;
      card.querySelectorAll('.cs-card__swatch[data-cs-src]').forEach(function (s) {
        var p = new Image(); p.src = s.dataset.csSrc;
      });
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var list = e.target.closest('.cs-card');
    if (!list) return;
    if (e.relatedTarget && list.contains(e.relatedTarget)) return;
    restore(list);
  });

  // Keyboard users get the same preview on focus.
  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('.cs-card__swatch');
    if (sw) swap(sw);
  });
  document.addEventListener('focusout', function (e) {
    var list = e.target.closest && e.target.closest('.cs-card');
    if (list && !(e.relatedTarget && list.contains(e.relatedTarget))) restore(list);
  });
})();

/* Product page: hover a color swatch to preview that colorway in the main photo. */
(function () {
  if (window.__colorSiblingsPdpInit) return;
  window.__colorSiblingsPdpInit = true;

  function galleryImg(fromEl) {
    var scope = fromEl.closest('[data-section-type], [data-section-id], .product-section, main') || document;
    var photos = scope.querySelector('[data-product-photos]') || document.querySelector('[data-product-photos]');
    if (!photos) return null;
    var slide = photos.querySelector('.product-main-slide.is-selected') ||
                photos.querySelector('.product-main-slide.starting-slide') ||
                photos.querySelector('.product-main-slide');
    if (!slide) return null;
    return slide.querySelector('.image-wrap img') || slide.querySelector('img');
  }

  function swap(sw) {
    if (!sw.dataset.csSrc) return;
    var img = galleryImg(sw);
    if (!img) return;
    var row = sw.closest('.color-siblings');
    if (row && row.__csImg && row.__csImg !== img) restore(row);
    if (!img.hasAttribute('data-cs-orig-src')) {
      img.setAttribute('data-cs-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-cs-orig-srcset', img.getAttribute('srcset') || '');
    }
    if (row) row.__csImg = img;
    img.setAttribute('srcset', sw.dataset.csSrcset || '');
    img.setAttribute('src', sw.dataset.csSrc);
  }

  function restore(row) {
    var img = row.__csImg;
    if (!img || !img.hasAttribute('data-cs-orig-src')) return;
    var oss = img.getAttribute('data-cs-orig-srcset');
    if (oss) img.setAttribute('srcset', oss); else img.removeAttribute('srcset');
    img.setAttribute('src', img.getAttribute('data-cs-orig-src'));
    img.removeAttribute('data-cs-orig-src');
    img.removeAttribute('data-cs-orig-srcset');
    row.__csImg = null;
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var row = e.target.closest('.color-siblings');
    if (!row) return;
    if (!row.__csPreloaded) {
      row.__csPreloaded = true;
      row.querySelectorAll('.color-siblings__swatch[data-cs-src]').forEach(function (s) {
        var p = new Image(); p.src = s.dataset.csSrc;
      });
    }
    var sw = e.target.closest('.color-siblings__swatch');
    if (sw) swap(sw);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var row = e.target.closest('.color-siblings');
    if (!row) return;
    var sw = e.target.closest('.color-siblings__swatch');
    // Leaving the whole row, or moving from a swatch onto a gap/the current color: restore.
    if (e.relatedTarget && row.contains(e.relatedTarget)) {
      var next = e.relatedTarget.closest && e.relatedTarget.closest('.color-siblings__swatch[data-cs-src]');
      if (sw && !next) restore(row);
      return;
    }
    restore(row);
  });

  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('.color-siblings__swatch');
    if (sw) swap(sw);
  });
  document.addEventListener('focusout', function (e) {
    var row = e.target.closest && e.target.closest('.color-siblings');
    if (row && !(e.relatedTarget && row.contains(e.relatedTarget))) restore(row);
  });
})();
